import ActionUtility from "../../utilities/ActionUtility";
import DataEffect from "./DataEffect";

export default class DataAction {

    static REQUEST_DATA = 'DataAction.REQUEST_DATA';
    static SET_MONTH_DATA = 'DataAction.SET_MONTH_DATA';
    static SET_DAY_DATA = 'DataAction.SET_DAY_DATA';
    static SET_TIME_DATA = 'DataAction.SET_TIME_DATA';
    static SET_OPTION_DATA = 'DataAction.SET_OPTION_DATA';
    static SET_REMARK_DATA = 'DataAction.SET_REMARK_DATA';
    static SUBMIT_HANDLER = 'DataAction.SUBMIT_HANDLER';
    static NEXT_STEP = 'DataAction.NEXT_STEP';
    static NAV_STEP = 'DataAction.NAV_STEP';

    static requestData() {

        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.REQUEST_DATA, DataEffect.requestData);
        }

    }

    static setMonthData(data) {

        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.SET_MONTH_DATA, DataEffect.setMonthData, data);
        }

    }

    static setDayData(data) {

        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.SET_DAY_DATA, DataEffect.setDayData, data);
        }

    }

    static setTimeData(data) {

        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.SET_TIME_DATA, DataEffect.setTimeData, data);
        }

    }

    static setOptionData(data) {

        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.SET_OPTION_DATA, DataEffect.setOptionData, data);
        }

    }

    static setRemarkData(data) {
        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.SET_REMARK_DATA, DataEffect.setRemarkData, data);
        }

    }

    static submitHandler(data) {
        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.SUBMIT_HANDLER, DataEffect.submitHandler, data);
        }

    }

    static nextStep() {

        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.NEXT_STEP, DataEffect.nextStep);
        }

    }

    static navStep(step) {

        return async (dispatch, getState) => {
            await ActionUtility.createThunkEffect(dispatch, DataAction.NAV_STEP, DataEffect.navStep, step);
        }

    }
}
